export const handlePrevState = <T extends unknown>(filter: T[], val: T) => {
  if (filter.includes(val)) return filter.filter((el) => el !== val);
  return [...filter, val];
};
